var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteRocket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2474 10.1022L9.74821 13.7015C9.41649 13.9669 8.93829 13.9404 8.63791 13.64L6.35844 11.3605C6.05807 11.0601 6.03158 10.5819 6.29695 10.2502L9.89628 5.75107C11.5422 3.69373 14.034 2.49609 16.6687 2.49609C17.1291 2.49609 17.5023 2.86935 17.5023 3.32977C17.5023 5.96445 16.3047 8.45628 14.2474 10.1022Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3339 10.8329V14.4861C13.3339 14.8019 13.1555 15.0905 12.8731 15.2317L10.859 16.2388C10.6428 16.3469 10.3904 16.3559 10.1671 16.2634C9.94383 16.1709 9.77168 15.9861 9.69525 15.7568L9.16554 14.1676",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83082 10.8329L4.24169 10.3032C4.01241 10.2268 3.82759 10.0546 3.7351 9.83133C3.64262 9.60805 3.65157 9.35562 3.75965 9.13946L4.76674 7.12535C4.90795 6.84293 5.19659 6.6645 5.51235 6.6645H9.16554",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7888 17.1579L2.49609 17.5023L2.84053 15.2096C2.95226 14.4659 3.53611 13.882 4.27987 13.7703C4.81733 13.6895 5.36122 13.8686 5.74553 14.253C6.12983 14.6373 6.30894 15.1811 6.22818 15.7186C6.11643 16.4624 5.53256 17.0462 4.7888 17.1579Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3339 10.8329V14.4861C13.3339 14.8019 13.1555 15.0905 12.8731 15.2317L10.859 16.2388C10.6428 16.3469 10.3904 16.3559 10.1671 16.2634C9.94383 16.1709 9.77168 15.9861 9.69525 15.7568L9.16554 14.1676M5.83082 10.8329L4.24169 10.3032C4.01241 10.2268 3.82759 10.0546 3.7351 9.83133C3.64262 9.60805 3.65157 9.35562 3.75965 9.13946L4.76674 7.12535C4.90795 6.84293 5.19659 6.6645 5.51235 6.6645H9.16554M14.2474 10.1022L9.74821 13.7015C9.41649 13.9669 8.93829 13.9404 8.63791 13.64L6.35844 11.3605C6.05807 11.0601 6.03158 10.5819 6.29695 10.2502L9.89628 5.75107C11.5422 3.69373 14.034 2.49609 16.6687 2.49609C17.1291 2.49609 17.5023 2.86935 17.5023 3.32977C17.5023 5.96445 16.3047 8.45628 14.2474 10.1022ZM4.7888 17.1579L2.49609 17.5023L2.84053 15.2096C2.95226 14.4659 3.53611 13.882 4.27987 13.7703C4.81733 13.6895 5.36122 13.8686 5.74553 14.253C6.12983 14.6373 6.30894 15.1811 6.22818 15.7186C6.11643 16.4624 5.53256 17.0462 4.7888 17.1579Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRocket);
export default __webpack_public_path__ + "static/media/white-rocket.bea1a6806bd4facedf4936b1935435f2.svg";
export { ForwardRef as ReactComponent };